import {
  Footer,
  MainContent,
  Root,
  Scene,
  SidebarContent,
  SidebarDrawer,
  SidebarToolbar,
  SidebarTopbar,
  StateControllerContainer,
  Topbar,
} from './components/layout/Containers';
import { Main } from './components/layout/Main';
import { Sidebar } from './components/layout/Sidebar';
import { Hooks } from './hooks/Hooks';
import Logo from '/favicon-for-dark.png';

import { useEffect, useState } from 'react';
import { Flip, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import styled from 'styled-components';
import { LauncherWindow } from './components/launcher/LauncherWindow';
import { ContextMenu } from './components/views/ContextMenu';
import { FloatingPanels } from './components/views/floatingPanels/FloatingPanels';
import { Modals } from './components/views/modals/Modals';
import { Properties } from './components/views/properties/Properties';
import { SceneButtons } from './components/views/SceneButtons';
import { Drawer } from './components/views/sidebar/Drawer';
import { SidebarToolbarIcons } from './components/views/sidebar/icons/SidebarToolbarIcons';
import { SidebarTopbarIcons } from './components/views/sidebar/icons/SidebarTopbarIcons';
import { FullViewButton } from './components/views/stateViewController/FullViewButton';
import { StateViewController } from './components/views/stateViewController/StateViewController';
import { TopbarCorner } from './components/views/TopbarCorner';
import { TopbarMenu } from './components/views/TopbarMenu';
import editorInfo from './editorInfo.json';
import './fontello/css/fontello.css';

export const App = () => {
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      setIsReady(true);
    }, 1000);
  }, []);

  return (
    <Root>
      <Main>
        <Sidebar>
          <SidebarTopbar>
            <SidebarTopbarIcons />
          </SidebarTopbar>

          <SidebarContent>
            <SidebarToolbar>
              <SidebarToolbarIcons />
            </SidebarToolbar>
            <SidebarDrawer>
              <Drawer />
            </SidebarDrawer>
          </SidebarContent>
        </Sidebar>

        <MainContent>
          <Topbar>
            <TopbarMenu />
            <TopbarCorner />
          </Topbar>

          <Scene>
            <LauncherWindow />
            <FloatingPanels />
            <SceneButtons />
          </Scene>

          <Properties />

          <StateControllerContainer>
            <StateViewController />
          </StateControllerContainer>
        </MainContent>

        <ToastContainer
          theme="dark"
          position="top-center"
          transition={Flip}
        />
      </Main>

      <Footer>
        <div className="leftSideInfo">
          PatchKit Editor
          <span>
            {editorInfo.versionNumber} {editorInfo.versionLabel}
          </span>
        </div>

        <FullViewButton />
      </Footer>

      <ContextMenu />
      <Modals />
      <Hooks />

      {editorInfo.environment === 'staging' && <StagingIndicator />}
      <Curtain $isReady={isReady}>
        <img src={Logo} />
        <span>PatchKit Editor</span>
      </Curtain>
    </Root>
  );
};

const StagingIndicator = styled.div`
  opacity: 0.5;
  box-sizing: border-box;
  position: absolute;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 9999;
  border: 1px solid yellow;
  pointer-events: none;

  &:before {
    content: 'staging';
    position: absolute;
    right: 10px;
    bottom: 25px;
    font-size: 14px;
    color: yellow;
    font-family: 'Arial';
  }
`;

const Curtain = styled.div<{ $isReady?: boolean }>`
  position: fixed;
  z-index: 1000;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: var(--neutral-5);

  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  color: var(--main-1);
  font-family: var(--font-1);
  font-weight: 200;
  font-size: 20px;

  img {
    animation: slideLeft 1s;
  }

  span {
    font-size: 24px;
    animation: fadeIn 2s;
  }

  opacity: 1;
  transition: opacity 0.5s;
  ${({ $isReady }) => $isReady && 'opacity: 0; pointer-events: none;'}
`;
